<div class="flex flex-col" [ngClass]="{selected: selected, 'card-container': true}">
  <div class="flex place-content-between place-items-center card-header-container">
    <div class="flex flex-row place-content-start place-items-start title-container">
      <span class="mat-body-2">{{vehicle.year}} {{vehicle.make}} {{vehicle.model}}</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-col card-content-container">
    <div class="flex flex-col">
      <div class="flex place-content-start place-items-center">
        <span class="mat-body-1 card-line-1">VIN is {{vehicle.vin}}</span>
      </div>
      <div class="flex place-content-start place-items-center">
        <span class="primary-bullet">·</span>
        <span class="secondary-text" *ngIf="vehicle.licensePlateNumber; else noPlate">
          License plate is {{vehicle.licensePlateNumber}}
        </span>
        <ng-template #noPlate>
          <span class="secondary-text">Unknown license plate</span>
        </ng-template>
      </div>
      <div class="flex place-content-start place-items-center">
        <span class="primary-bullet">·</span>
        <span class="secondary-text" *ngIf="vehicle.currentMileage; else noMileage">
          Odometer is {{vehicle.currentMileage}}
        </span>
        <ng-template #noMileage>
          <span class="secondary-text">Unknown mileage</span>
        </ng-template>
      </div>
      <!-- <div fxLayoutAlign="start center">
        <span class="primary-bullet">·</span>
        <span class="secondary-text" *ngIf="associate.homePhoneNumber; else noHomePhone">
          M: {{associate.homePhoneNumber | phoneNumber}}
        </span>
        <ng-template #noHomePhone>
          <span class="secondary-text">No main number provided</span>
        </ng-template>
      </div> -->
    </div>
  </div>
</div>